import { TFilterDefaultLayers } from '@/shared/features/filter-preferences/utils/resolve-filter-defaults/resolve-filter-defaults.types';
import { TFilterDefaults } from '@/shared/types/ui-preferences.types';

// A key that exists (including '') wins; an absent key falls through to the next layer.
const read = (
  filters: Record<string, string> | undefined,
  param: string,
): string | undefined =>
  filters && param in filters ? filters[param] : undefined;

// A stored default exists on this layer — '' (explicitly cleared) counts.
export const hasLayerDefault = (
  defaults: TFilterDefaults | undefined,
  scopeKey: string,
  param: string,
): boolean => read(defaults?.[scopeKey]?.filters, param) !== undefined;

// A saved view supplies this param, so the scope has already seeded it.
export const hasViewDefault = (
  defaults: TFilterDefaults | undefined,
  scopeKey: string,
  param: string,
): boolean => read(defaults?.[scopeKey]?.view?.filters, param) !== undefined;

// A per-param default is the more specific choice, so it outranks the saved view
// it sits next to; both outrank the company layer.
export const resolveFilterDefault = (
  scopeKey: string,
  param: string,
  codeDefault: string | undefined,
  { user, company }: TFilterDefaultLayers,
): string | undefined => {
  const layers = [
    user?.[scopeKey]?.filters,
    user?.[scopeKey]?.view?.filters,
    company?.[scopeKey]?.filters,
  ];

  for (const filters of layers) {
    const value = read(filters, param);
    if (value !== undefined) return value;
  }

  return codeDefault;
};
